/* RW10 2026-10-03 (staging): PDP quantity presets + cart "also in stock" companions.
   Pairs with snippets/rww-qty-presets.liquid and sections/rww-cart-companions.liquid.
   Uses only tracking the page already has (gtag / Shopify.analytics); never loads a script. */
(function () {
  'use strict';
  if (window.__rwwCro) return; window.__rwwCro = 1;
  var TIERS = [[2500, 25], [1000, 20], [500, 15], [250, 10], [100, 5]]; // Bulk Tier Pricing RWW, per item
  function track(n, p) {
    try { if (typeof window.gtag === 'function') window.gtag('event', n, p || {}); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(n, p || {}); } catch (e) {}
  }
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function disc(n) { for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i][0]) return TIERS[i][1]; return 0; }
  function nextTier(n) { for (var i = TIERS.length - 1; i >= 0; i--) if (n < TIERS[i][0]) return TIERS[i]; return null; }

  /* ---------- PDP quantity presets ---------- */
  function qtyInput() { return document.querySelector('.js-product-form-main [name="quantity"]') || document.querySelector('product-form [name="quantity"]'); }
  function setQty(n) {
    var q = qtyInput(); if (!q) return;
    q.value = n;
    q.dispatchEvent(new Event('input', { bubbles: true }));
    q.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function paint(box) {
    var q = qtyInput(); if (!box || !q) return;
    var p = +box.dataset.price, min = +box.dataset.min || 1, n = Math.max(0, parseInt(q.value, 10) || 0);
    [].forEach.call(box.querySelectorAll('[data-q]'), function (b) { b.setAttribute('aria-pressed', +b.dataset.q === n ? 'true' : 'false'); });
    var line = box.querySelector('[data-rww-qty-line]'); if (!line) return;
    var d = disc(n), total = n * p * (100 - d) / 100;
    var html = '<b>' + n + ' pcs</b> × ' + money(p) + (d ? ' − ' + d + '% bulk' : '') + ' = <b>' + money(total) + '</b>';
    if (n < min) html += '<br><span class="rqp__rq">Below the $5.00 minimum for this size: add ' + (min - n) + ' more.</span>';
    else {
      var nt = nextTier(n);
      if (nt && nt[0] - n <= Math.max(50, n)) html += '<br><span class="rqp__ok">Add ' + (nt[0] - n) + ' more for ' + nt[1] + '% off this size.</span>';
    }
    line.innerHTML = html;
  }
  function initBox(box) {
    if (!box || box.__rqp) return; box.__rqp = 1;
    var q = qtyInput(), min = +box.dataset.min || 1;
    // The cart blocks any line under $5.00, so start at the minimum (and raise a smaller quantity after a material change).
    if (q && min > 1 && (parseInt(q.value, 10) || 0) < min) setQty(min);
    paint(box);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.rqp [data-q]'); if (!b) return;
    var box = b.closest('[data-rww-qty]'), n = +b.dataset.q;
    setQty(n); paint(box);
    track('rww_qty_preset', { qty: n, line_value: Math.round(n * (+box.dataset.price) * (100 - disc(n)) / 100) / 100 });
  });
  ['input', 'change'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target && e.target.name === 'quantity' && e.target.closest('.js-product-form-main, product-form')) paint(document.querySelector('[data-rww-qty]'));
    });
  });
  // Theme quantity +/- buttons change the value without always firing input; repaint after any click in the form.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-product-form-main')) setTimeout(function () { paint(document.querySelector('[data-rww-qty]')); }, 0);
  });

  /* ---------- Cart: also in stock, same material ---------- */
  function val(s) { var w = 0, m = String(s).match(/^(\d+)-(\d+\/\d+)$/); if (m) { w = +m[1]; s = m[2]; } if (String(s).indexOf('/') > -1) { var p = s.split('/'); return w + p[0] / p[1]; } return w + (+s); }
  function dims(title) { var m = String(title).match(/([\d\-\/]+)"\s*OD\s*x\s*([\d\-\/]+)"\s*ID\s*x\s*([\d\-\/]+)"/i); return m ? [val(m[1]), val(m[2]), val(m[3])] : null; }
  function initCart(box) {
    if (!box || box.__rcc) return; box.__rcc = 1;
    var mats = (box.dataset.mats || '').split('|').filter(Boolean), inCart = (box.dataset.handles || '').split('|').filter(Boolean);
    if (!mats.length) return;
    fetch('/collections/in-stock/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) {
        var ref = null, rows = [];
        (j.products || []).forEach(function (p) {
          if (inCart.indexOf(p.handle) > -1) { ref = ref || dims(p.title); return; }
          (p.variants || []).forEach(function (v) { if (v.available && mats.indexOf(v.title) > -1) rows.push({ p: p, v: v, d: dims(p.title) }); });
        });
        if (!ref) { var t = document.querySelector('.cart-item__title, .cart-item a[href*="/products/"]'); ref = t ? dims(t.textContent) : null; }
        if (ref) rows.forEach(function (r) { r.s = r.d ? Math.abs(r.d[1] - ref[1]) * 3 + Math.abs(r.d[2] - ref[2]) * 6 + Math.abs(r.d[0] - ref[0]) : 99; });
        rows.sort(function (a, b) { return (a.s || 0) - (b.s || 0); });
        rows = rows.slice(0, 4);
        if (!rows.length) return;
        box.querySelector('[data-rww-cc-h]').textContent = 'Also in stock in ' + mats.join(' & ');
        box.querySelector('[data-rww-cc-l]').innerHTML = rows.map(function (r) {
          var c = Math.round(parseFloat(r.v.price) * 100), min = c < 500 ? Math.ceil(500 / c) : 1;
          var name = r.p.title.replace(/^Rubber Washer\s*/i, '').replace(/\s*Thick$/i, ' thick');
          return '<li><a href="/products/' + r.p.handle + '?variant=' + r.v.id + '" data-cc="' + esc(r.p.handle) + '"><span>' + esc(name) +
            '<span class="rcc__m">' + esc(r.v.title) + ' · ' + money(c) + ' each</span></span><span class="rcc__p">' + (min > 1 ? 'min ' + min + ' pcs<br>' + money(min * c) : money(c)) + '</span></a></li>';
        }).join('');
        box.hidden = false;
        track('rww_cart_companions_shown', { count: rows.length });
      }).catch(function () {});
    box.addEventListener('click', function (e) { var a = e.target.closest('a[data-cc]'); if (a) track('rww_cart_companion_click', { handle: a.getAttribute('data-cc') }); });
  }

  // RW11 2026-10-03 speed: the cart list needs the 425 KB in-stock feed, so it is fetched only after window load,
  // when the browser is idle (it used to run inside DOMContentLoaded). The box stays hidden until filled.
  function lazyCart(box) {
    if (!box) return;
    var go = function () { ('requestIdleCallback' in window) ? requestIdleCallback(function () { initCart(box); }, { timeout: 2000 }) : setTimeout(function () { initCart(box); }, 300); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  function run() {
    // RW11: raising the quantity to the $5 minimum fires the theme's input/change handlers (price, app tier table);
    // do it in the first idle slot instead of inside the DOMContentLoaded task. Nobody can tap Add before that.
    var qb = document.querySelector('[data-rww-qty]');
    if (qb) { qb.__rqpPending = 1; ('requestIdleCallback' in window) ? requestIdleCallback(function () { initBox(qb); }, { timeout: 800 }) : setTimeout(function () { initBox(qb); }, 50); }
    lazyCart(document.querySelector('[data-rww-cc]'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // The theme re-renders variant blocks (data-dynamic-variant-content) when the material changes.
  try {
    // RW11: one check per frame instead of one per mutation while the page builds.
    var pend = 0;
    new MutationObserver(function () { if (pend) return; pend = 1; requestAnimationFrame(function () { pend = 0; var b = document.querySelector('[data-rww-qty]'); if (b && !b.__rqp && !b.__rqpPending) initBox(b); }); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
